module.exports = __webpack_public_path__ + "img/绞股蓝.dbbf09f2.jpg";